@if (organizations(); as organizations) {
    @if (organizations.loading) {
        <div class="flex justify-center py-8">
            <pandora-spinner />
        </div>
    } @else {
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" autoAnimate>
            @for (organization of organizations.data.organizations.nodes; track organization.id) {
                <div
                    role="button"
                    tabindex="0"
                    (keydown.enter)="onClickListItem(organization)"
                    (keydown.space)="$event.preventDefault(); onClickListItem(organization)"
                    (click)="onClickListItem(organization)"
                    class="relative rounded-lg border border-gray-300 bg-white p-6 shadow-sm hover:border-blue-400 hover:shadow-md cursor-pointer transition-all flex flex-col items-center text-center group"
                >
                    <div class="w-20 h-20 mb-4 flex items-center justify-center">
                        <img
                            alt="{{ organization.name }} logo"
                            [src]="organization.logoUrl"
                            class="max-w-full max-h-full object-contain"
                        />
                    </div>
                    <div class="flex-1">
                        <h3 class="text-lg font-semibold text-gray-900 group-hover:text-blue-600">
                            {{ organization.name }}
                        </h3>
                        <p class="text-sm text-gray-500 mt-1">
                            {{ organization.subdomain }}.ares.sale
                        </p>
                    </div>
                    <div class="mt-4">
                        <span class="inline-flex items-center text-sm font-medium text-blue-600 group-hover:text-blue-700">
                            Selecteer
                            <app-icon [icon]="chevronIcon" size="table" class="ml-1" />
                        </span>
                    </div>
                </div>
            }
        </div>
    }
}
